// extracted by mini-css-extract-plugin
export default {"TravelCTAs":"TravelCTAs_TravelCTAs__Ceckd","rotation":"TravelCTAs_rotation__fxpg1"};